import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestAuthentication } from 'shared/actions/authentication';
import { NewbuildingBrokerSidebarBanner } from 'shared/components/NewbuildingBrokerSidebarBanner';
import { selectIsAuthenticated } from 'shared/selectors';
import { selectIsUnmatchedContentExperiment } from 'shared/selectors/abExperiments';
import { selectDIYEnabled } from 'shared/selectors/newbuildingBrokerDIY';
import { trackDIYEntryPointClick, trackDIYEntryPointShow } from 'shared/utils/newbuildingBroker/DIY';

import { NewbuildingBrokerModalsContext } from '../NewbuildingBrokerModalsProvider';

const ENTRYPOINT = 'card_independent_banner_at_sidebar';

export const NewbuildingBrokerSidebarBannerContainer: React.FC = () => {
  const isDIYEnabled = useSelector(selectDIYEnabled);
  const isUnmatchedContentExperiment = useSelector(selectIsUnmatchedContentExperiment);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { loadingPlace, startMicrofrontOpening } = React.useContext(NewbuildingBrokerModalsContext);
  const isLoading = loadingPlace === ENTRYPOINT;

  const dispatch = useDispatch();

  const handleShow = React.useCallback(() => {
    trackDIYEntryPointShow(ENTRYPOINT);
  }, []);

  const handleClick = React.useCallback(() => {
    trackDIYEntryPointClick(ENTRYPOINT);

    if (isAuthenticated) {
      startMicrofrontOpening(ENTRYPOINT);
    } else {
      dispatch(
        requestAuthentication({
          onSuccess: () => () => startMicrofrontOpening(ENTRYPOINT),
        }),
      );
    }
  }, [dispatch, startMicrofrontOpening, isAuthenticated]);

  if (!isDIYEnabled || !isUnmatchedContentExperiment) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow}>
      <NewbuildingBrokerSidebarBanner loading={isLoading} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
